window.theme = window.theme || {};
window.slate = window.slate || {};

/* ================ SLATE ================ */
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');


    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
    );
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    src = src || '';

    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match === null) {
      return null;
    } else {
      return match[1];
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * 2048 Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

// ===== High-variant picker (optimistic UI + single-flight render) V2 =====
(function () {
  'use strict';

  class VariantSelects extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.sectionId = this.getAttribute('data-section-id');
      this.productUrl = this.getAttribute('data-url') || window.location.pathname;

      this.isRendering = false;
      this.renderQueued = false;
      this.renderQueuedFor = 0;
      this.pendingInput = null;
      this.interactionId = 0;

      this.currentVariantId = null;
      this.currentProductPath = this._normalizePath(this.productUrl);

      this._abort = null;

      this.addEventListener('change', (e) => this._onChange(e));
      this.addEventListener('click', (e) => this._onClick(e));

      this.syncUrlFromSelectedVariant();
    }

    disconnectedCallback() {
      this._abortRequest();
      this.renderQueued = false;
    }

    _escapeSelector(val) {
      const s = String(val ?? '');
      if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(s);
      return s.replace(/([ #;&,.+*~':"!^$[\]()=>|/@\\])/g, '\\$1');
    }

    _normalizePath(urlLike) {
      try {
        return new URL(urlLike, window.location.origin).pathname;
      } catch (_) {
        return window.location.pathname;
      }
    }

    _abortRequest() {
      if (this._abort) {
        try {
          this._abort.abort();
        } catch (_) {}
      }
      this._abort = null;
    }

    getSectionRoot(scope = document) {
      const root = scope && scope.querySelector ? scope : document;

      const psId = `ProductSection-${this.sectionId}`;
      const ssId = `shopify-section-${this.sectionId}`;

      return (
        root.querySelector(`#${this._escapeSelector(psId)}`) ||
        root.querySelector(`#${this._escapeSelector(ssId)}`) ||
        root.querySelector(`[data-section-id="${this._escapeSelector(this.sectionId)}"]`) ||
        null
      );
    }

    captureScrollState() {
      this._winY = window.pageYOffset || document.documentElement.scrollTop || 0;
      const grid = this.querySelector('.ColorSwatchGrid');
      this._gridScrollY = grid ? grid.scrollTop : 0;
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    }

    restoreScrollState() {
      const grid = this.querySelector('.ColorSwatchGrid');
      const snap = () => {
        window.scrollTo(0, this._winY || 0);
        if (grid) grid.scrollTop = this._gridScrollY || 0;
      };
      snap();
      requestAnimationFrame(snap);
      setTimeout(snap, 0);
    }

    captureOptionState() {
      this._optionState = [];
      this.querySelectorAll('[data-option-index]').forEach((fs) => {
        const idx = fs.getAttribute('data-option-index');
        const r = fs.querySelector('input[type="radio"][name]:checked');
        if (!r) return;
        this._optionState.push({
          index: idx,
          name: r.name,
          idAttr: r.id || null,
          optValId: r.getAttribute('data-option-value-id') || r.dataset.optionValueId || null,
          value: r.value
        });
      });
    }

    restoreOptionState(scope) {
      const root = scope || this;
      (this._optionState || []).forEach((sel) => {
        let target = null;

        if (sel.idAttr) {
          target = root.querySelector('#' + this._escapeSelector(sel.idAttr));
        }

        if (!target && sel.optValId) {
          const fs = root.querySelector(`[data-option-index="${this._escapeSelector(sel.index)}"]`);
          if (fs) {
            target = fs.querySelector(
              `input[type="radio"][data-option-value-id="${this._escapeSelector(sel.optValId)}"]`
            );
          }
        }

        if (!target) {
          target = root.querySelector(
            `input[type="radio"][name="${this._escapeSelector(sel.name)}"][value="${this._escapeSelector(sel.value)}"]`
          );
        }

        if (target) {
          target.checked = true;
          try {
            target.focus({ preventScroll: true });
          } catch (_) {}
        }
      });
    }

    extractSelectedVariant(scope = document) {
      const section = this.getSectionRoot(scope) || (scope.querySelector ? scope : document);
      const jsonNode = section.querySelector('[data-selected-variant]');
      if (!jsonNode) return null;

      try {
        const parsed = JSON.parse(jsonNode.textContent || 'null');
        if (parsed && typeof parsed === 'object') return parsed;
        return null;
      } catch (err) {
        console.error('[variant-selects] Error parsing [data-selected-variant] JSON:', err);
        return null;
      }
    }

    extractVariantId(scope = document) {
      const v = this.extractSelectedVariant(scope);
      if (v && v.id) return String(v.id);

      const section = this.getSectionRoot(scope) || (scope.querySelector ? scope : document);

      const hiddenIdInput = section.querySelector('input[type="hidden"][name="id"]');
      if (hiddenIdInput && hiddenIdInput.value) return String(hiddenIdInput.value);

      const selectId = section.querySelector('select[name="id"]');
      if (selectId && selectId.value) return String(selectId.value);

      const checkedRadio = section.querySelector('input[type="radio"][name]:checked');
      if (checkedRadio && checkedRadio.dataset && checkedRadio.dataset.variantId) {
        return String(checkedRadio.dataset.variantId);
      }
      if (checkedRadio && checkedRadio.value && /^\d+$/.test(checkedRadio.value)) {
        return String(checkedRadio.value);
      }

      return null;
    }

    computeAvailability(scope = document) {
      const v = this.extractSelectedVariant(scope);
      if (v && typeof v.available === 'boolean') return v.available;
      return null;
    }

    updateVariantInputs(sectionEl, variantId) {
      if (!sectionEl) return;

      const marked = sectionEl.querySelectorAll('[data-variant-input]');
      if (marked && marked.length) {
        marked.forEach((el) => {
          if (el.tagName === 'INPUT' && el.name === 'id') el.value = variantId || '';
        });
      }

      const hiddenInputs = sectionEl.querySelectorAll('input[type="hidden"][name="id"]');
      hiddenInputs.forEach((inp) => {
        inp.value = variantId || '';
      });
    }

    applyAvailabilityClasses(sectionEl, isAvailable) {
      if (!sectionEl) return;
      const qtyWrap = sectionEl.querySelector('.product-form__item--quantity');
      if (qtyWrap) qtyWrap.classList.toggle('hide', !isAvailable);
    }

    updateAddToCartUI(targetSection, sourceSection, opts) {
      if (!targetSection) return;

      const variantId = opts?.variantId || null;
      const isAvailable = !!opts?.isAvailable;

      this.applyAvailabilityClasses(targetSection, variantId && isAvailable);

      const actionBtn =
        targetSection.querySelector('.product-form-btn') ||
        targetSection.querySelector('.product-form__cart-submit');

      const bisBtn =
        targetSection.querySelector('.bis-button.klaviyo-bis-trigger') ||
        targetSection.querySelector('.bis-button');

      if (!actionBtn) return;

      const freshBtn =
        sourceSection?.querySelector('.product-form-btn') ||
        sourceSection?.querySelector('.product-form__cart-submit');

      const setDisabled = (btn, disabled) => {
        btn.disabled = !!disabled;
        btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      };

      if (!variantId) {
        actionBtn.classList.remove('cart-button');
        actionBtn.classList.add('btn--sold-out');
        actionBtn.classList.remove('hidden');
        actionBtn.textContent = 'Unavailable';
        setDisabled(actionBtn, true);

        if (bisBtn) {
          bisBtn.classList.add('hidden');
          bisBtn.removeAttribute('data-variant-id');
          if (bisBtn.dataset) delete bisBtn.dataset.variantId;
        }
        return;
      }

      if (isAvailable) {
        actionBtn.classList.remove('btn--sold-out', 'hidden');
        actionBtn.classList.add('cart-button');
        setDisabled(actionBtn, false);

        if (freshBtn) actionBtn.textContent = freshBtn.textContent.trim();

        if (bisBtn) bisBtn.classList.add('hidden');
        return;
      }

      actionBtn.classList.remove('cart-button');
      actionBtn.classList.add('btn--sold-out', 'hidden');
      setDisabled(actionBtn, true);

      if (bisBtn) {
        bisBtn.classList.remove('hidden');
        bisBtn.textContent = 'ON BACKORDER! Notify Me When Available';
        if (bisBtn.dataset) bisBtn.dataset.variantId = variantId;
      }
    }

    mergeColorSwatchGrid(preservedGrid, freshGrid) {
      try {
        if (!preservedGrid || !freshGrid) return;
        if (!preservedGrid.classList || !freshGrid.classList) return;
        if (!preservedGrid.classList.contains('ColorSwatchGrid')) return;
        if (!freshGrid.classList.contains('ColorSwatchGrid')) return;

        const freshInputs = Array.from(freshGrid.querySelectorAll('input[type="radio"][id]'));
        if (!freshInputs.length) return;

        const frag = document.createDocumentFragment();

        const syncKnownInputAttrs = (dst, src) => {
          const attrs = ['name', 'value', 'class', 'aria-label', 'data-option-value-id', 'data-product-url'];
          attrs.forEach((a) => {
            if (src.hasAttribute(a)) dst.setAttribute(a, src.getAttribute(a));
            else dst.removeAttribute(a);
          });

          dst.disabled = !!src.disabled;
          if (src.disabled) dst.setAttribute('disabled', '');
          else dst.removeAttribute('disabled');

          dst.checked = !!src.checked;
          if (src.checked) dst.setAttribute('checked', '');
          else dst.removeAttribute('checked');
        };

        const syncLabelPresentation = (dstLbl, srcLbl) => {
          if (!dstLbl || !srcLbl) return;

          dstLbl.className = srcLbl.className;

          if (srcLbl.hasAttribute('aria-hidden')) dstLbl.setAttribute('aria-hidden', srcLbl.getAttribute('aria-hidden'));
          else dstLbl.removeAttribute('aria-hidden');

          const dstText = dstLbl.querySelector('.ColorTile__Text');
          const srcText = srcLbl.querySelector('.ColorTile__Text');
          if (dstText && srcText) dstText.innerHTML = srcText.innerHTML;

          const dstThumb = dstLbl.querySelector('.ColorTile__Thumb');
          const srcThumb = srcLbl.querySelector('.ColorTile__Thumb');
          if (dstThumb && srcThumb) {
            const dstIcon = dstThumb.querySelector('.stockout-icon');
            const srcIcon = srcThumb.querySelector('.stockout-icon');
            if (srcIcon && !dstIcon) dstThumb.appendChild(srcIcon.cloneNode(true));
            if (!srcIcon && dstIcon) dstIcon.remove();

            
            const dstImg = dstThumb.querySelector('img');
            const srcImg = srcThumb.querySelector('img');
            if (dstImg && srcImg) {
              const imgAttrs = ['src', 'srcset', 'sizes', 'width', 'height', 'loading', 'decoding'];
              imgAttrs.forEach((a) => {
                if (srcImg.hasAttribute(a)) dstImg.setAttribute(a, srcImg.getAttribute(a));
                else dstImg.removeAttribute(a);
              });
            }
          }
        };

      
        freshInputs.forEach((fInp) => {
          const id = fInp.id;
          if (!id) return;

          const fLbl = freshGrid.querySelector(`label[for="${this._escapeSelector(id)}"]`);
          if (!fLbl) return;

          const pInp = preservedGrid.querySelector(`#${this._escapeSelector(id)}`);
          const pLbl = preservedGrid.querySelector(`label[for="${this._escapeSelector(id)}"]`);

          if (pInp && pLbl) {
            syncKnownInputAttrs(pInp, fInp);
            syncLabelPresentation(pLbl, fLbl);
            frag.appendChild(pInp);
            frag.appendChild(pLbl);
          } else {
            frag.appendChild(fInp.cloneNode(true));
            frag.appendChild(fLbl.cloneNode(true));
          }
        });

        preservedGrid.replaceChildren(frag);
      } catch (err) {
        console.error('[variant-selects] mergeColorSwatchGrid failed:', err);
      }
    }

    syncAvailabilityFromFresh(freshScope) {
      const freshRoot = this.getSectionRoot(freshScope) || (freshScope?.querySelector ? freshScope : null);
      if (!freshRoot) return;

      const freshStateById = new Map();

      freshRoot.querySelectorAll('input[type="radio"][name][id]').forEach((inp) => {
        const id = inp.id;
        const lbl = freshRoot.querySelector(`label[for="${this._escapeSelector(id)}"]`);
        freshStateById.set(id, {
          disabled: !!inp.disabled,
          aria: inp.getAttribute('aria-label') || null,
          stockout: !!(lbl && lbl.classList && lbl.classList.contains('stockout'))
        });
      });

      this.querySelectorAll('input[type="radio"][name][id]').forEach((inp) => {
        const state = freshStateById.get(inp.id);
        if (!state) return;

        inp.disabled = !!state.disabled;
        if (state.aria) inp.setAttribute('aria-label', state.aria);

        const lbl = this.querySelector(`label[for="${this._escapeSelector(inp.id)}"]`);
        if (lbl && lbl.classList && lbl.classList.contains('ColorTile')) {
          lbl.classList.toggle('stockout', !!state.stockout);
        }
      });
    }

    selectedOptionValueIds() {
      const ids = [];
      this.querySelectorAll('[data-option-index]').forEach((fs) => {
        const checked = fs.querySelector('input[type="radio"][name]:checked');
        if (!checked) return;
        const val = checked.getAttribute('data-option-value-id') || checked.dataset.optionValueId;
        if (val) ids.push(val);
      });
      return ids;
    }

    selectedProductUrlIfAny() {
      const checked = this.querySelector('input[type="radio"][name]:checked[data-product-url]');
      return checked ? checked.getAttribute('data-product-url') : null;
    }

    updateBrowserUrl(baseUrl, variantId) {
      const display = new URL(window.location.href);

      try {
        const base = new URL(baseUrl, window.location.origin);
        display.pathname = base.pathname;
      } catch (_) {}

      display.searchParams.delete('section_id');
      display.searchParams.delete('option_values');

      if (variantId) display.searchParams.set('variant', variantId);
      else display.searchParams.delete('variant');

      history.replaceState({}, '', display.toString());
    }

    syncUrlFromSelectedVariant() {
      const id = this.extractVariantId(document);
      if (!id) return;
      this.currentVariantId = id;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      url.searchParams.delete('section_id');
      url.searchParams.delete('option_values');
      history.replaceState({}, '', url.toString());
    }

    _onChange(e) {
      if (!e.target.matches('input[type="radio"][name]')) return;
      try {
        e.target.focus({ preventScroll: true });
      } catch (_) {}
      this.scheduleRender(e.target);
    }

    _onClick(e) {
      const label = e.target.closest && e.target.closest('.ColorTile, label[for]');
      if (!label) return;
      requestAnimationFrame(() => this.restoreScrollState());
    }

    scheduleRender(input) {
      if (this.pendingInput) this.pendingInput.removeAttribute('data-pending');
      this.pendingInput = input || this.querySelector('input[type="radio"][name]:checked');
      if (this.pendingInput) this.pendingInput.setAttribute('data-pending', 'true');
      this.setAttribute('data-busy', 'true');

      this.captureScrollState();
      this.captureOptionState();

      this.interactionId++;
      queueMicrotask(() => this._renderSingleFlight(this.interactionId));
    }

    async _renderSingleFlight(myInteractionId) {
      if (this.isRendering) {
        this.renderQueued = true;
        this.renderQueuedFor = myInteractionId;
        return;
      }

      this.isRendering = true;

      try {
        const ids = this.selectedOptionValueIds();
        const baseUrl = this.selectedProductUrlIfAny() || this.productUrl;

        const req = new URL(baseUrl, window.location.origin);
        req.searchParams.set('section_id', this.sectionId);
        if (ids.length) req.searchParams.set('option_values', ids.join(','));
        else req.searchParams.delete('option_values');

        this._abortRequest();
        this._abort = new AbortController();

        const res = await fetch(req.toString(), {
          credentials: 'same-origin',
          signal: this._abort.signal
        });

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const html = await res.text();
        if (myInteractionId !== this.interactionId) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');

        const freshSection = this.getSectionRoot(doc) || doc.querySelector('body > *');
        if (!freshSection) return;

        const selectedVariant = this.extractSelectedVariant(doc);
        const freshVariantId = selectedVariant?.id ? String(selectedVariant.id) : null;

        const freshAvailRaw = this.computeAvailability(doc);
        const isAvailable = !!(freshVariantId && freshAvailRaw === true);

        this.updateBrowserUrl(baseUrl, freshVariantId);

        const newPath = this._normalizePath(baseUrl);
        this.currentProductPath = newPath;
        this.productUrl = newPath;
        this.setAttribute('data-url', newPath);

        const currentSection = this.getSectionRoot(document);
        if (!currentSection) return;

        const preserved = {};
        currentSection.querySelectorAll('[data-preserve]').forEach((el) => {
          const key = el.getAttribute('data-preserve');
          if (!key) return;
          preserved[key] = el;
          el.remove();
        });

        const replaceElementInner = (oldEl, newEl) => {
          if (!oldEl || !newEl) return false;
          const oldHTML = (oldEl.innerHTML || '').trim();
          const newHTML = (newEl.innerHTML || '').trim();
          if (oldHTML === newHTML) return true;
          oldEl.innerHTML = newEl.innerHTML;
          return true;
        };

        const patchSection = (oldSection, newSection) => {
          if (!oldSection || !newSection) return false;

          Array.from(newSection.attributes || []).forEach((attr) => {
            const oldVal = oldSection.getAttribute(attr.name);
            if (oldVal !== attr.value) oldSection.setAttribute(attr.name, attr.value);
          });

          let didPatch = false;

          newSection.querySelectorAll('[data-section-part]').forEach((fPart) => {
            const partName = fPart.getAttribute('data-section-part');
            if (!partName) return;

            const oldPart = oldSection.querySelector(
              `[data-section-part="${this._escapeSelector(partName)}"]`
            );

            if (oldPart) {
              replaceElementInner(oldPart, fPart);
              didPatch = true;
            }
          });

          return didPatch;
        };

        let patched = false;
        try {
          patched = patchSection(currentSection, freshSection);
        } catch (err) {
          console.error('[variant-selects] patchSection failed:', err);
          patched = false;
        }

        if (!patched) {
          console.warn('[variant-selects] full section swap fallback');
          currentSection.replaceWith(freshSection);
        }

        if (!this.isConnected) return;

        const newSection = this.getSectionRoot(document);
        if (!newSection) return;

        Object.keys(preserved).forEach((key) => {
          const target = newSection.querySelector(
            `[data-preserve="${this._escapeSelector(key)}"]`
          );

          if (target && preserved[key]) {
         
            if (
              target.classList &&
              preserved[key].classList &&
              target.classList.contains('ColorSwatchGrid') &&
              preserved[key].classList.contains('ColorSwatchGrid')
            ) {
              this.mergeColorSwatchGrid(preserved[key], target);
            }

            target.replaceWith(preserved[key]);
          }
        });

        this.syncAvailabilityFromFresh(doc);

        this.updateVariantInputs(newSection, freshVariantId);

        const bisBtn = newSection.querySelector('.bis-button');
        if (bisBtn) {
          if (freshVariantId && bisBtn.dataset) bisBtn.dataset.variantId = freshVariantId;
          else if (bisBtn.dataset) delete bisBtn.dataset.variantId;
        }

        this.restoreOptionState(this);

        if (this.pendingInput) {
          const wantedId = this.pendingInput.id;
          const wantedOptVal =
            this.pendingInput.getAttribute('data-option-value-id') ||
            this.pendingInput.dataset.optionValueId;

          let focusTarget = null;

          if (wantedId) focusTarget = document.getElementById(wantedId);

          if (!focusTarget && wantedOptVal) {
            focusTarget = this.querySelector(
              `input[type="radio"][data-option-value-id="${this._escapeSelector(wantedOptVal)}"]`
            );
          }

          if (focusTarget) {
            focusTarget.checked = true;
            try {
              focusTarget.focus({ preventScroll: true });
            } catch (_) {}
          }
        }

        if (window.bindProductThumbs) setTimeout(() => window.bindProductThumbs(this.sectionId), 0);
        if (window.rebindViewportFixes) setTimeout(() => window.rebindViewportFixes(), 0);
        if (typeof this._productZoomImage === 'function')
          setTimeout(() => this._productZoomImage(), 0);

        this.updateAddToCartUI(newSection, freshSection, {
          variantId: freshVariantId,
          isAvailable
        });

        requestAnimationFrame(() => this.restoreScrollState());
        setTimeout(() => this.restoreScrollState(), 0);

        this.currentVariantId = freshVariantId;
      } catch (err) {
        if (err && (err.name === 'AbortError' || err.code === 20)) return;
        console.error('[variant-selects] render error:', err);
      } finally {
        this.removeAttribute('data-busy');
        if (this.pendingInput) this.pendingInput.removeAttribute('data-pending');
        this.pendingInput = null;

        this.isRendering = false;

        if (this.renderQueued && this.isConnected) {
          const nextId = this.renderQueuedFor || this.interactionId;
          this.renderQueued = false;
          this.renderQueuedFor = 0;
          this._renderSingleFlight(nextId);
        }
      }
    }
  }

  if (!customElements.get('variant-selects')) {
    customElements.define('variant-selects', VariantSelects);
  }
})();



/*================ MODULES ================*/
window.Drawers = (function() {
  var Drawer = function(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('body, html'),
      $page: $('.page-element'),
      $moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);
    this.$open = $(this.config.open);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function() {
    this.$open.attr('aria-expanded', 'false');
    this.$open.on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened drawer
    if (this.drawerIsOpen) {
      return;
    }

    this.$open.addClass(this.config.openClass);

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.nodes.$moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Drawer.prototype.close = function() {
    // don't close a closed drawer
    if (!this.drawerIsOpen) {
      return;
    }

    this.$open.removeClass(this.config.openClass);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.nodes.$moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    // Clicking out of drawer closes it
    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );

    // Pressing escape closes drawer
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

theme.Hero = (function() {
  var selectors = {
    hero: '.hero',
    heroWrapper: '.hero-wrapper',
    heroArrows: '.hero__arrow',
    heroImage: '.hero__image',
    heroPause: '.hero__pause'
  };

  function Hero() {
    this.namespace = '.hero';
    this.$hero = $(selectors.hero);
    this.$hero.on('init' + this.namespace, this._a11y.bind(this));
    this.$hero.on('init' + this.namespace, this._arrowsInit.bind(this));

    this.$hero.slick({
      accessibility: true,
      arrows: false, // this theme has custom arrows
      draggable: false,
      autoplay: this.$hero.data('autoplay'),
      autoplaySpeed: this.$hero.data('speed')
    });

    $(selectors.heroImage).on(
      'click' + this.namespace,
      function() {
        this.$hero.slick('slickNext');
      }.bind(this)
    );

    $(selectors.heroPause).on(
      'click' + this.namespace,
      function() {
        if ($(selectors.heroPause).hasClass('is-paused')) {
          this._play();
        } else {
          this._pause();
        }
      }.bind(this)
    );
  }

  Hero.prototype = _.assignIn({}, Hero.prototype, {
    _pause: function() {
      this.$hero.slick('slickPause');
      $(selectors.heroPause).addClass('is-paused');
    },

    _play: function() {
      this.$hero.slick('slickPlay');
      $(selectors.heroPause).removeClass('is-paused');
    },

    _a11y: function(event, obj) {
      var $list = obj.$list;

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused
      // pause slideshow and set aria-live
      $(selectors.heroWrapper).on(
        'focusin' + this.namespace,
        function(evt) {
          if (!$(selectors.heroWrapper).has(evt.target).length) {
            return;
          }

          $list.attr('aria-live', 'polite');
          this._pause();
        }.bind(this)
      );

      // Resume autoplay
      $(selectors.heroWrapper).on(
        'focusout' + this.namespace,
        function(evt) {
          if (!$(selectors.heroWrapper).has(evt.target).length) {
            return;
          }

          $list.removeAttr('aria-live');
          this._play();
        }.bind(this)
      );
    },

    _arrowsInit: function(event, obj) {
      // Slider is initialized. Setup custom arrows
      var count = obj.slideCount;
      var $slider = obj.$slider;
      var $arrows = $(selectors.heroArrows);

      if ($arrows.length && count > 1) {
        $arrows.on(
          'click' + this.namespace,
          function(evt) {
            evt.preventDefault();
            if ($(evt.currentTarget).hasClass('hero__arrow--prev')) {
              $slider.slick('slickPrev');
            } else {
              $slider.slick('slickNext');
            }

            this._scrollTop();
          }.bind(this)
        );
      } else {
        $arrows.remove();
      }
    },

    _scrollTop: function() {
      var currentScroll = $(document).scrollTop();
      var heroOffset = this.$hero.offset().top;

      if (currentScroll > heroOffset) {
        $('html')
          .add('body')
          .animate(
            {
              scrollTop: heroOffset
            },
            250
          );
      }
    },

    goToSlide: function(slideIndex) {
      this.$hero.slick('slickGoTo', slideIndex);
    },

    pause: function() {
      this.$hero.slick('slickPause');
    },

    play: function() {
      this.$hero.slick('slickPlay');
    },

    destroy: function() {
      this.$hero.off(this.namespace);
      $(selectors.heroImage).off(this.namespace);
      $(selectors.heroPause).off(this.namespace);
      $(selectors.heroWrapper).off(this.namespace);
      $(selectors.heroArrows).off(this.namespace);

      this.$hero.slick('unslick');
    }
  });

  return Hero;
})();

window.Modals = (function() {
  var Modal = function(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $body: $('body')
    };

    this.config = $.extend(defaults, options);

    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen
      ? $(this.config.focusOnOpen)
      : this.$modal;
    this.init();
  };

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      return this.close();
    }

    this.$modal.prepareTransition().addClass(this.config.openClass);
    this.nodes.$body.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      $container: this.$modal,
      namespace: 'modal_focus',
      $elementToFocus: this.$focusOnOpen
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.prepareTransition().removeClass(this.config.openClass);
    this.nodes.$body.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$body.on(
      'keyup.modal',
      $.proxy(function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this)
    );
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$body.off('.modal');
  };

  return Modal;
})();

window.Meganav = (function() {
  var Meganav = function(options) {
    this.cache = {
      $document: $(document),
      $page: $('.page-element')
    };

    var defaults = {
      $meganavs: $('.meganav'),
      $megaNav: $('.meganav__nav'),
      $meganavToggle: $('.meganav-toggle'),
      $meganavDropdownContainers: $('.site-nav__dropdown-container'),
      $meganavToggleThirdLevel: $('.meganav__link-toggle'),
      $meganavLinkSecondLevel: $('.meganav__link--second-level'),
      $meganavLinkThirdLevel: $('.meganav__link--third-level'),
      $meganavDropdownThirdLevel: $('.site-nav__dropdown--third-level'),
      isOpen: false,
      preventDuplicates: false,
      closeOnPageClick: false,
      closeThirdLevelOnBlur: false,
      activeClass: 'meganav--active',
      drawerClass: 'meganav--drawer',
      meganavDropdown: '.site-nav__dropdown',
      meganavLinkClass: 'meganav__link',
      drawerToggleClass: 'drawer__nav-toggle-btn',
      drawerNavItem: '.drawer__nav-item',
      navCollectionClass: 'meganav__nav--collection',
      secondLevelClass: 'meganav__link--second-level',
      thirdLevelClass: 'meganav__link-toggle',
      thirdLevelContainerClass: 'site-nav__dropdown--third-level',
      noAnimationClass: 'meganav--no-animation'
    };

    this.config = $.extend(defaults, options);
    this.init();
  };

  Meganav.prototype.init = function() {
    var $openBtn = this.config.$meganavToggle;

    $openBtn.on('click', $.proxy(this.requestMeganav, this));

    if (this.config.closeThirdLevelOnBlur) {
      this.config.$meganavLinkThirdLevel.on(
        'blur',
        $.proxy(this.closeThirdLevelMenu, this)
      );
    }
  };

  Meganav.prototype.requestMeganav = function(evt) {
    var $targetedMeganav;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    }

    // Without this, the meganav opens, the click event bubbles up to
    // theme.cache.$page which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
    }

    var $el = $(evt.currentTarget);
    var anotherNavIsOpen = this.config.isOpen;
    var isThirdLevelBtn = $el.hasClass(this.config.thirdLevelClass);

    // The $targetedMeganav is different for the drawer and non-drawer navs
    if ($el.hasClass(this.config.drawerToggleClass)) {
      $targetedMeganav = $el
        .closest(this.config.drawerNavItem)
        .children('.' + this.config.drawerClass);
    } else {
      $targetedMeganav = $el.siblings(this.config.meganavDropdown);
    }

    // Navigate to link href or close menu if already active
    if ($el.hasClass(this.config.activeClass) && $el.is('a')) {
      window.location = $el.attr('href');
      return;
    }

    // If true, don't let multiple meganavs be open simultaneously
    if (!isThirdLevelBtn && this.config.preventDuplicates) {
      this.close();
    }

    if ($targetedMeganav.hasClass(this.config.drawerClass)) {
      var isExpanded = $el.attr('aria-expanded') === 'true';

      $el
        .toggleClass(this.config.activeClass)
        .attr('aria-expanded', !isExpanded);

      $targetedMeganav.stop().slideToggle(200);
    } else {
      $el.addClass(this.config.activeClass).attr('aria-expanded', 'true');

      // Show targeted nav, letting it know whether another meganav is already open
      this.open($el, $targetedMeganav, anotherNavIsOpen);
    }

    // Setup event handlers when meganav is open
    this.bindEvents();
    this.config.isOpen = true;

    // If dropdown has third level, calculate width for container
    var $dropdown = $el.next();
    var isCollection = $dropdown
      .find(this.config.$megaNav)
      .hasClass(this.config.navCollectionClass);

    if (isCollection) {
      this.updateThirdLevelContainerWidth($el, $dropdown);
    }
  };

  Meganav.prototype.updateThirdLevelContainerWidth = function($el, $dropdown) {
    var $thirdLevel = $dropdown.find(this.config.$meganavDropdownThirdLevel);

    if (!$thirdLevel.length) {
      return;
    }

    $.each(
      $thirdLevel,
      function(key, container) {
        var $container = $(container);
        var $lastChild = $container.find('li:last-child');

        this.updateContainerWidth($container, $lastChild);
      }.bind(this)
    );
  };

  Meganav.prototype.updateContainerWidth = function(container, element) {
    var containerRect = container[0].getBoundingClientRect();
    var elementRect = element[0].getBoundingClientRect();

    if (elementRect.left < containerRect.right) {
      return;
    }

    var columnWidth = containerRect.width;
    var containerFixedWidth =
      elementRect.left + columnWidth - containerRect.left;
    var numberOfColumns = containerFixedWidth / columnWidth;
    var containerPercentageWidth = numberOfColumns * 20;

    container
      .width(containerPercentageWidth + '%')
      .find('li')
      .css('width', 100 / numberOfColumns + '%');
  };

  Meganav.prototype.open = function($el, $target, noAnimation) {
    var isThirdLevelBtn = $el.hasClass(this.config.thirdLevelClass);

    $target.addClass(this.config.activeClass);

    if (isThirdLevelBtn) {
      this.toggleSubNav($el, $target);
    }

    // Add class to override animation - CSS determined
    if (noAnimation) {
      $target.addClass(this.config.noAnimationClass);
    }
  };

  Meganav.prototype.toggleSubNav = function($el) {
    this.removeMenuActiveState();

    $el
      .addClass(this.config.activeClass)
      .attr('aria-expanded', 'true')
      .siblings(this.config.$meganavDropdownThirdLevel)
      .addClass(this.config.activeClass);

    $el.parent().addClass(this.config.activeClass);
  };

  Meganav.prototype.close = function(evt, $target) {
    if (this.config.preventDuplicates) {
      // Close all meganavs
      this.config.$meganavs.removeClass(
        [this.config.activeClass, this.config.noAnimationClass].join(' ')
      );
      this.config.$meganavToggle
        .removeClass(this.config.activeClass)
        .attr('aria-expanded', 'false');

      this.config.$meganavDropdownContainers.removeClass(
        this.config.activeClass
      );
    } else {
      // Close targeted nav
      var $targetedMeganav = $('#' + $target.attr('aria-controls'));
      $targetedMeganav.removeClass(
        [this.config.activeClass, this.config.noAnimationClass].join(' ')
      );
      $target
        .removeClass(this.config.activeClass)
        .attr('aria-expanded', 'false');
    }

    // Remove event listeners
    this.unbindEvents();
    this.config.isOpen = false;
  };

  Meganav.prototype.closeThirdLevelMenu = function(evt) {
    var $el = $(evt.currentTarget);
    var $parent = $el.parent();

    if (!$parent.is(':last-child')) {
      return;
    }

    this.config.$meganavLinkSecondLevel.one(
      'focus.meganav',
      $.proxy(function() {
        this.removeMenuActiveState();
      }, this)
    );
  };

  Meganav.prototype.removeMenuActiveState = function() {
    var activeClasses = [this.config.activeClass, this.config.noAnimationClass];

    this.config.$meganavToggleThirdLevel
      .removeClass(activeClasses.join(' '))
      .attr('aria-expanded', 'false');

    this.config.$meganavDropdownThirdLevel.removeClass(activeClasses.join(' '));
    this.config.$meganavDropdownContainers.removeClass(this.config.activeClass);
  };

  Meganav.prototype.bindEvents = function() {
    if (!this.config.closeOnPageClick) {
      return;
    }

    // Clicking away from the meganav will close it
    this.cache.$page.on('click.meganav', $.proxy(this.close, this));

    // Exception to above: clicking anywhere on the meganav will NOT close it
    this.config.$meganavs.on(
      'click.meganav',
      function(evt) {
        // 3rd level container
        var is3rdLevelMenuTarget =
          $(evt.currentTarget).hasClass(this.config.activeClass) &&
          $(evt.currentTarget).hasClass(this.config.thirdLevelContainerClass);

        // 2nd level mega link
        var isMegaNavlink =
          $(evt.target).hasClass(this.config.meganavLinkClass) &&
          $(evt.target).hasClass(this.config.secondLevelClass);

        // If we click anything outside from the 3rd level megaNav, close the third level menu (except for 2nd level links)
        if (!is3rdLevelMenuTarget && !isMegaNavlink) {
          this.removeMenuActiveState();
        }

        evt.stopImmediatePropagation();
      }.bind(this)
    );

    // Pressing escape closes meganav and focuses the target parent link
    this.cache.$document.on(
      'keyup.meganav',
      $.proxy(function(evt) {
        if (evt.keyCode !== 27) return;

        this.config.$meganavToggle
          .filter('.' + this.config.activeClass)
          .focus();
        this.close();
      }, this)
    );
  };

  Meganav.prototype.unbindEvents = function() {
    if (!this.config.closeOnPageClick) {
      return;
    }

    this.cache.$page.off('.meganav');
    this.config.$meganavs.off('.meganav');
    this.cache.$document.off('.meganav');
    this.config.$meganavLinkSecondLevel.off('.meganav');
    this.config.$meganavLinkThirdLevel.off('.meganav');
  };

  return Meganav;
})();

window.QtySelector = (function() {
  var QtySelector = function($el) {
    this.cache = {
      $body: $('body'),
      $subtotal: $('#CartSubtotal'),
      $discountTotal: $('#cartDiscountTotal'),
      $cartTable: $('.cart-table'),
      $cartTemplate: $('#CartProducts')
    };

    this.settings = {
      loadingClass: 'js-qty--is-loading',
      isCartTemplate: this.cache.$body.hasClass('template-cart'),
      // On the cart template, minimum is 0. Elsewhere min is 1
      minQty: this.cache.$body.hasClass('template-cart') ? 0 : 1
    };

    this.$el = $el;
    this.qtyUpdateTimeout;
    this.createInputs();
    this.bindEvents();
  };

  QtySelector.prototype.createInputs = function() {
    var $el = this.$el;

    var data = {
      value: $el.val(),
      key: $el.attr('id'),
      name: $el.attr('name'),
      line: $el.attr('data-line')
    };
    var source = $('#QuantityTemplate').html();
    var template = Handlebars.compile(source);

    this.$wrapper = $(template(data)).insertBefore($el);

    // Remove original number input
    $el.remove();
  };

  QtySelector.prototype.validateAvailability = function(line, quantity) {
    var product = theme.cartObject.items[line - 1]; // 0-based index in API
    var handle = product.handle; // needed for the ajax request
    var id = product.id; // needed to find right variant from ajax results

    var params = {
      type: 'GET',
      url: '/products/' + handle + '.js',
      dataType: 'json',
      success: $.proxy(function(cartProduct) {
        this.validateAvailabilityCallback(line, quantity, id, cartProduct);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.validateAvailabilityCallback = function(
    line,
    quantity,
    id,
    product
  ) {
    var quantityIsAvailable = true;

    // This returns all variants of a product.
    // Loop through them to get our desired one.
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.id === id) {
        break;
      }
    }

    // If the variant tracks inventory and does not sell when sold out
    // we can compare the requested with available quantity
    if (
      variant.inventory_management !== null &&
      variant.inventory_policy === 'deny'
    ) {
      if (variant.inventory_quantity < quantity) {
        // Show notification with error message
        theme.Notify.open('error', theme.strings.noStockAvailable, true);

        // Set quantity to max amount available
        this.$wrapper.find('.js-qty__input').val(variant.inventory_quantity);

        quantityIsAvailable = false;
        this.$wrapper.removeClass(this.settings.loadingClass);
      }
    }

    if (quantityIsAvailable) {
      this.updateItemQuantity(line, quantity);
    }
  };

  QtySelector.prototype.validateQty = function(qty) {
    if (parseFloat(qty) === parseInt(qty, 10) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return parseInt(qty, 10);
  };

  QtySelector.prototype.adjustQty = function(evt) {
    var $el = $(evt.currentTarget);
    var $input = $el.siblings('.js-qty__input');
    var qty = this.validateQty($input.val());
    var line = $input.attr('data-line');

    if ($el.hasClass('js-qty__adjust--minus')) {
      qty -= 1;
      if (qty <= this.settings.minQty) {
        qty = this.settings.minQty;
      }
    } else {
      qty += 1;
    }

    if (this.settings.isCartTemplate) {
      $el.parent().addClass(this.settings.loadingClass);
      this.updateCartItemPrice(line, qty);
    } else {
      $input.val(qty);
    }
  };

  QtySelector.prototype.bindEvents = function() {
    this.$wrapper
      .find('.js-qty__adjust')
      .on('click', $.proxy(this.adjustQty, this));

    // Select input text on click
    this.$wrapper.on('click', '.js-qty__input', function() {
      this.setSelectionRange(0, this.value.length);
    });

    // If the quantity changes on the cart template, update the price
    if (this.settings.isCartTemplate) {
      this.$wrapper.on(
        'change',
        '.js-qty__input',
        $.proxy(function(evt) {
          var $input = $(evt.currentTarget);
          var line = $input.attr('data-line');
          var qty = this.validateQty($input.val());
          $input.parent().addClass(this.settings.loadingClass);
          this.updateCartItemPrice(line, qty);
        }, this)
      );
    }
  };

  QtySelector.prototype.updateCartItemPrice = function(line, qty) {
    // Update cart after short timeout so user doesn't create simultaneous ajax calls
    clearTimeout(this.qtyUpdateTimeout);
    this.qtyUpdateTimeout = setTimeout(
      $.proxy(function() {
        this.validateAvailability(line, qty);
      }, this),
      100
    );
  };

  QtySelector.prototype.updateItemQuantity = function(line, quantity) {
    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: $.proxy(function(cart) {
        this.updateCartItemCallback(cart);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.updateCartItemCallback = function(cart) {

    // Reload the page to show the empty cart if no items
    if (cart.item_count === 0) {
      location.reload();
      return;
    }

    // Update cart object
    theme.cartObject = cart;

    // Handlebars.js cart layout
    var data = {};
    var items = [];
    var item = {};
    var source = $('#CartProductTemplate').html();
    var template = Handlebars.compile(source);
    var prodImg;
    var cartitemm;

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add 240x240, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */

      if (cartItem.image === null) {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      } else {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_240x240$1')
          .replace('http:', '');
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        cartitemm: cart.item_count,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemQty: cartItem.quantity,
        price: theme.Currency.formatMoney(cartItem.price, theme.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: theme.Currency.formatMoney(
          cartItem.line_price,
          theme.moneyFormat
        ),
        originalLinePrice: theme.Currency.formatMoney(
          cartItem.original_line_price,
          theme.moneyFormat
        ),
        discounts: cartItem.discounts,
        discountsApplied:
          cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items
    };
    this.cache.$cartTemplate.empty().append(template(data));

    // Create new quantity selectors
    this.cache.$cartTable.find('input[type="number"]').each(function(i, el) {
      new QtySelector($(el));
    });

    // Update the cart subtotal
    this.cache.$subtotal.html(
      theme.Currency.formatMoney(cart.total_price, theme.moneyFormat)
    );

    // Update the cart total discounts
    if (cart.total_discount > 0) {
      this.cache.$discountTotal.html(
        theme.strings.totalCartDiscount.replace(
          '[savings]',
          theme.Currency.formatMoney(cart.total_discount, theme.moneyFormat)
        )
      );
    } else {
      this.cache.$discountTotal.empty();
    }

    // Set focus on cart table
    slate.a11y.pageLinkFocus(this.cache.$cartTable);

  };

  return QtySelector;
})();

/*
  Allow product to be added to cart via ajax with
  custom success and error responses.
*/
window.AjaxCart = (function() {
  var cart = function($form) {
    this.cache = {
      $cartIconIndicator: $('.site-header__cart-indicator'),
      //$cartIcon: $('.cartcount')
      $carttext: $('#AddToCartText-product-template'),
    };

    this.$form = $form;
    this.eventListeners();
  };
   
 

  cart.prototype.eventListeners = function() {
    if (this.$form.length) {
      this.$form.on('submit', $.proxy(this.addItemFromForm, this));
    }
  };

  cart.prototype.addItemFromForm = function(evt) {
    evt.preventDefault();

    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: this.$form.serialize(),
      dataType: 'json',
      success: $.proxy(function(lineItem) {
        this.success(lineItem);  
      },
      
      this),
      error: $.proxy(function(XMLHttpRequest, textStatus) {
        this.error(XMLHttpRequest, textStatus);
      }, this)
    };


    $.ajax(params);

  };
  
  cart.prototype.success = function(lineItem) {
    var qty = this.addedQty();
    // Product pages: the added-to-cart card. Elsewhere (no card on the page): the old blue bar.
    var usedCard = !!(theme.CartAddedCard && theme.CartAddedCard.show(lineItem, qty));
    if (!usedCard) {
      this.updateAddedMessage();
      theme.Notify.open('success', false, true);
    }
    // Update cart notification bubble's state (+ the card's cart count / subtotal)
   setTimeout(function() {
  jQuery.getJSON('/cart.js', function(cart) {
    var count = Number(cart.item_count) || 0;
    var ariaLabel = 'Your cart is empty';

    if (count === 1) {
      ariaLabel = '1 item in your cart';
    } else if (count > 1) {
      ariaLabel = count + ' items in your cart';
    }

    jQuery('span.cart-item-count').text(count);
    jQuery('a.site-header__cart').attr('aria-label', ariaLabel);
    if (usedCard) theme.CartAddedCard.summary(cart);
  });
}, 100);
    $('#AddToCartText-product-template').text('Added!').css({'background': '#004eb7', 'color': '#fff', 'display':'block', 'padding':'15px 0' }).delay(800).fadeOut(300);
    setTimeout('$("#AddToCartText-product-template").text("Add to cart").css({"background": "#004eb7", "color": "#fff", "display":"block", "padding":"15px 0" }).fadeIn(300);',1100);
    this.cache.$cartIconIndicator.removeClass('hide');
     $('.check-cart-out').removeClass('hide');
    $('.check-cart').addClass('hide');    
  };

  /* Added-to-cart message text: "✓ 15 items added to cart". The "View cart & check out" link
     next to it lives in sections/header.liquid. Uses the quantity just submitted from the visible
     quantity box (apps can add hidden quantity inputs), not the line's running total in the cart.
     "to cart" is dropped on phones (.ntf__long) so the bar stays on one line. */
  /* Quantity just submitted, from the visible quantity box (apps can add hidden quantity inputs). */
  cart.prototype.addedQty = function() {
    var $qty = this.$form.find('.product-form__item--quantity input[name="quantity"]:visible').first();
    if (!$qty.length) $qty = this.$form.find('input[name="quantity"]').not('[type="hidden"]').first();
    var qty = parseInt($qty.val(), 10);
    return qty > 0 ? qty : 1;
  };

  cart.prototype.updateAddedMessage = function() {
    var $msg = $('#NotificationSuccess .notification__message');
    if (!$msg.length) return;

    var qty = this.addedQty();
    var count = qty === 1 ? '1 item' : qty.toLocaleString('en-US') + ' items';

    $msg.html(
      '<svg class="ntf__icon" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10"/><path d="M8 12.5l2.5 2.5L16 9.5"/></svg>' +
      '<span><strong>' + count + '</strong> added<span class="ntf__long"> to cart</span></span>'
    );
  };

  // Error handling reference from Shopify.onError in api.jquery.js
  cart.prototype.error = function(XMLHttpRequest) {
    var data = JSON.parse(XMLHttpRequest.responseText);

    if (data.message) {
      theme.Notify.open('error', data.description, true);
    }
  };

  return cart;
})();

/*
  Added-to-cart card (snippets/cart-added-card.liquid, product pages).
  Not a modal: focus stays where it was, the page stays usable. Repeated adds update the same card
  and restart the timer. Closes itself after 8 s; stays while hovered or focused (then 4 s after
  leaving); × / Escape close.
*/
theme.CartAddedCard = (function() {
  var el = null;
  var live = null;
  var timer = null;
  var SHOW_MS = 10000;  // time on screen (room to read the free-shipping line)
  var lastMsg = '';
  var lastAdded = 0;    // cents just added (to tell "this add unlocked free shipping")
  var RESUME_MS = 4000; // after the mouse / focus leaves the card

  function q(sel) { return el.querySelector(sel); }
  function money(cents) { return theme.Currency.formatMoney(cents, theme.moneyFormat || '${{amount}}'); }

  function close() {
    if (!el || el.hidden) return;
    clearTimeout(timer);
    el.hidden = true;
  }

  function arm(ms) {
    clearTimeout(timer);
    timer = setTimeout(close, ms);
  }

  function init() {
    if (el) return true;
    el = document.getElementById('CartAddedCard');
    live = document.getElementById('CartAddedLive');
    if (!el) return false;

    el.addEventListener('click', function(e) {
      if (e.target.closest('[data-cart-card-close]')) close();
    });
    el.addEventListener('mouseenter', function() { clearTimeout(timer); });
    el.addEventListener('mouseleave', function() { if (!el.contains(document.activeElement)) arm(RESUME_MS); });
    el.addEventListener('focusin', function() { clearTimeout(timer); });
    el.addEventListener('focusout', function(e) { if (!el.contains(e.relatedTarget)) arm(RESUME_MS); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !el.hidden) close();
    });
    return true;
  }

  function imageUrl(item) {
    var src = (item.featured_image && item.featured_image.url) || item.image || '';
    if (!src) return '';
    try {
      var u = new URL(src, window.location.origin);
      u.searchParams.set('width', '160');
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  function show(item, qty) {
    if (!item || !init()) return false;
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';

    // fixed 64x64 box with a loading shade; the picture fades in once loaded (no jump, no old image)
    var img = q('[data-cart-card-img]');
    var src = imageUrl(item);
    var box = img.parentNode;
    box.classList.add('is-loading');
    img.onload = function() { box.classList.remove('is-loading'); };
    img.onerror = function() { box.classList.remove('is-loading'); };
    if (src) { if (img.getAttribute('src') !== src) img.src = src; else box.classList.remove('is-loading'); }
    else { img.removeAttribute('src'); box.classList.remove('is-loading'); }

    q('[data-cart-card-name]').textContent = item.product_title || item.title || '';
    q('[data-cart-card-meta]').textContent = (variant ? variant + ' \u00b7 ' : '') + 'Qty ' + qty.toLocaleString('en-US');
    var price = q('[data-cart-card-price]');
    var unit = typeof item.final_price === 'number' ? item.final_price : item.price;
    price.textContent = typeof unit !== 'number' ? '' : money(unit * qty);
    lastAdded = typeof unit === 'number' ? unit * qty : 0;
    var ship = q('[data-cart-card-ship]');
    if (ship) ship.hidden = true; // filled once the cart total arrives
    price.hidden = !price.textContent;
    // cart count + subtotal arrive a moment later (/cart.js); the row keeps its height meanwhile
    q('[data-cart-card-summary]').classList.add('is-loading');
    q('[data-cart-card-count]').textContent = '';
    q('[data-cart-card-subtotal]').textContent = '';

    el.hidden = false;
    el.classList.remove('is-bump');
    void el.offsetWidth; // restart the small "updated" animation on repeated adds
    el.classList.add('is-bump');
    arm(SHOW_MS);

    if (live) {
      live.textContent = '';
      var msg = qty.toLocaleString('en-US') + ' \u00d7 ' + (variant || item.product_title || '') + ' added to cart.';
      lastMsg = msg;
      setTimeout(function() { live.textContent = msg; }, 60);
    }
    return true;
  }

  function summary(cart) {
    if (!el || el.hidden || !cart) return;
    var n = Number(cart.item_count) || 0;
    q('[data-cart-card-count]').textContent = 'Cart: ' + n.toLocaleString('en-US') + (n === 1 ? ' item' : ' items');
    // q('[data-cart-card-subtotal]').textContent = 'Subtotal ' + money(cart.total_price);
    q('[data-cart-card-subtotal]').innerHTML =`Subtotal <span class="subtotal-price">${money(cart.total_price)}</span>`;
    q('[data-cart-card-summary]').classList.remove('is-loading');

    // free-shipping line
    var ship = q('[data-cart-card-ship]');
    var fs = theme.FreeShip && theme.FreeShip.state(cart, lastAdded);
    if (ship && fs && fs.state !== 'empty') {
      ship.className = 'cart-card__ship cart-card__ship--' + fs.state;
      var text = q('[data-cart-card-ship-text]');
      if (fs.state === 'pending') text.innerHTML = 'Add <b class="fs-amt">' + money(fs.left) + '</b> more for free shipping';
      else if (fs.state === 'just') text.innerHTML = '<b>Your order now qualifies</b> for free US shipping on eligible orders';
      else text.innerHTML = '<b>Your order qualifies</b> for free US shipping on eligible orders';
      var bar = q('[data-cart-card-ship-bar]');
      bar.style.width = '0%';
      void bar.offsetWidth;
      bar.style.width = fs.pct + '%';
      ship.hidden = false;
      if (live && lastMsg) {
        var shipMsg = fs.state === 'pending'
          ? 'Add ' + money(fs.left) + ' more for free shipping.'
          : (fs.state === 'just' ? 'Your order now qualifies' : 'Your order qualifies') + ' for free US shipping on eligible orders.';
        live.textContent = lastMsg + ' ' + shipMsg;
      }
    }
  }

  return { show: show, summary: summary, close: close };
})();

/* Free shipping: one place that turns a cart into a state, using the goal and minimum rendered by
   snippets/free-shipping-bar.liquid (data-fs-goal $195, data-fs-min $150) on the product-page pill
   or the cart page's checkout block. custom.js calls update() after any cart change; the
   added-to-cart card asks state() for its line.
   States: empty (cart under the minimum) · pending (amount left) · just (this add crossed the goal)
   · qualified. Free shipping itself is applied at checkout on eligible items. */
theme.FreeShip = (function() {
  function pill() { return document.getElementById('FreeShipPill'); }
  function num(attr, fallback) {
    var p = document.querySelector('[data-fs-goal]');
    var v = p ? parseInt(p.getAttribute(attr), 10) : NaN;
    return isNaN(v) ? fallback : v;
  }
  function goal() { return num('data-fs-goal', 19500); }
  function minimum() { return num('data-fs-min', 15000); }
  function money(cents) { return theme.Currency.formatMoney(cents, theme.moneyFormat || '${{amount}}'); }

  function state(cart, addedCents) {
    // no free-shipping element on the page = not offered here (e.g. outside the US): say nothing
    if (!document.querySelector('[data-fs-goal]')) return { state: 'empty', left: 0, pct: 0 };
    var total = Number(cart && cart.total_price) || 0;
    var count = Number(cart && cart.item_count) || 0;
    var g = goal();
    var left = Math.max(0, g - total);
    var pct = g > 0 ? Math.min(100, Math.round((total / g) * 100)) : 100;
    var s = 'pending';
    if (count === 0 || total < minimum()) s = 'empty';
    else if (left === 0) s = (total - (addedCents || 0) < g) ? 'just' : 'qualified';
    return { state: s, left: left, pct: pct };
  }

  function update(cart) {
    var st = state(cart, 0);

    // product pages: header pill
    var p = pill();
    if (p) {
      var slot = document.getElementById('FreeShipSlot');
      if (slot) slot.hidden = st.state === 'empty';
      p.className = 'fs-pill fs-pill--' + st.state;
      var t = p.querySelector('[data-fs-text]');
      if (t) {
        if (st.state === 'pending') t.innerHTML = 'Add <b class="fs-amt">' + money(st.left) + '</b> more for free shipping';
        else t.textContent = 'Your order qualifies for free US shipping on eligible orders';
      }
    }

    // cart page: line in the checkout block + the note under it
    var box = document.getElementById('CartFreeShip');
    if (box) {
      var row = box.querySelector('[data-fs-row]');
      var txt = box.querySelector('[data-fs-text]');

      row.hidden = st.state === 'empty';
      row.className = 'cart-fs__row cart-fs__row--' + st.state;
      if (st.state === 'pending') txt.innerHTML = 'Add <b class="fs-amt">' + money(st.left) + '</b> more for free shipping';
      else if (st.state === 'qualified') txt.innerHTML = '<b>Your order qualifies</b> for free US shipping on eligible orders';
      // the cart's tax / shipping note is left exactly as it is
    }
  }

  return { state: state, update: update };
})();

window.Notify = (function() {
  
  var notify = function() {
    this.cache = {
      $scrollParent: $('html').add('body'),
      $notificationSuccess: $('#NotificationSuccess'),
      $notificationSuccessLink: $('#NotificationSuccess').find('a'),
      $notificationError: $('#NotificationError'),
      $notificationPromo: $('#NotificationPromo'),
      $notificationClose: $('.notification__close'),
      $notificationErrorMessage: $('.notification__message--error')
    };
    this.settings = {
      notifyActiveClass: 'notification--active',
      closeTimer: 5000,
      promoKeyName: 'promo-' + (this.cache.$notificationPromo.data('text') || '')
    };

    this.notifyTimer = null;
    this.$lastFocusedElement = null;

    this.isLocalStorageSupported = isLocalStorageSupported();
    this.cache.$notificationClose.on('click', this.close.bind(this));
  };

  function isLocalStorageSupported() {
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    try {
      var storage = window.sessionStorage;
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  notify.prototype.open = function(state, message, autoclose) {
    this.close();

    if (state === 'success') {
      this.cache.$notificationSuccess
        .attr('aria-hidden', false)
        .addClass(this.settings.notifyActiveClass);

      this.$lastFocusedElement = $(document.activeElement);

      this.cache.$notificationSuccess.one(
        'TransitionEnd webkitTransitionEnd transitionend oTransitionEnd',
        $.proxy(function() {
          slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink);
        }, this)
      );

      if (this.cache.$scrollParent.hasClass('no-csstransitions')) {
        slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink);
      }
    } else {
      this.cache.$notificationErrorMessage.html(message);
      this.cache.$notificationError
        .attr('aria-hidden', false)
        .addClass(this.settings.notifyActiveClass);
    }

    if (autoclose) {
      clearTimeout(this.notifyTimer);
      this.notifyTimer = setTimeout(
        this.close.bind(this),
        this.settings.closeTimer
      );
    }
  };

  notify.prototype.close = function(evt) {
    if (
      this.$lastFocusedElement &&
      this.cache.$notificationSuccessLink.is(':focus')
    ) {
      slate.a11y.pageLinkFocus(this.$lastFocusedElement);
    }

    this.cache.$notificationSuccess
      .attr('aria-hidden', true)
      .removeClass(this.settings.notifyActiveClass);
    this.cache.$notificationError
      .attr('aria-hidden', true)
      .removeClass(this.settings.notifyActiveClass);

    this.$lastFocusedElement = null;
  };

  notify.prototype.showPromo = function(SFEevent) {
    return;
  };

  return notify;
})();


theme.Maps = (function() {
  var config = {
    zoom: 14,
    styles: [
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#cacaca' }, { lightness: 17 }]
      },
      {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [{ color: '#e1e1e1' }, { lightness: 20 }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [{ color: '#ffffff' }, { lightness: 17 }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }]
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [{ color: '#ffffff' }, { lightness: 18 }]
      },
      {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [{ color: '#ffffff' }, { lightness: 16 }]
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#e1e1e1' }, { lightness: 21 }]
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#bbbbbb' }, { lightness: 21 }]
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [{ visibility: 'on' }, { color: '#ffffff' }, { lightness: 16 }]
      },
      {
        elementType: 'labels.text.fill',
        stylers: [{ saturation: 36 }, { color: '#333333' }, { lightness: 40 }]
      },
      { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [{ color: '#f2f2f2' }, { lightness: 19 }]
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.fill',
        stylers: [{ color: '#fefefe' }, { lightness: 20 }]
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }]
      }
    ] // eslint-disable-line key-spacing, comma-spacing
  };
  var apiStatus = null;
  var mapsToLoad = [];

  function Map(container) {
    theme.$currentMapContainer = this.$container = $(container);
    var key = this.$container.data('api-key');

    if (typeof key !== 'string' || key === '') {
      return;
    }

    if (apiStatus === 'loaded') {
      var self = this;

      // Check if the script has previously been loaded with this key
      var $script = $('script[src*="' + key + '&"]');
      if ($script.length === 0) {
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + key
        ).then(function() {
          apiStatus = 'loaded';
          self.createMap();
        });
      } else {
        this.createMap();
      }
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              styles: config.styles,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());
            var enablePin = $map.data('enable-pin');

            var markerColor = $map.data('marker-color');

            var markerIcon = {
              path:
                'M57.7,0C25.8,0,0,25.8,0,57.7C0,89.5,50,170,57.7,170s57.7-80.5,57.7-112.3C115.3,25.8,89.5,0,57.7,0z M57.7,85 c-14.9,0-27-12.1-27-27c0-14.9,12.1-27,27-27c14.9,0,27,12.1,27,27C84.7,72.9,72.6,85,57.7,85z',
              fillColor: markerColor,
              fillOpacity: 0.9,
              scale: 0.2,
              strokeWeight: 0
            };

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: center,
              icon: markerIcon,
              visible: enablePin
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          // Only show error in the theme editor
          if (Shopify.designMode) {
            var $mapContainer = $map.parents('.map-section');

            $mapContainer.addClass('page-width map-section--load-error');
            $mapContainer.find('.map-section__content-wrapper').remove();
            $mapContainer
              .find('.map-section__wrapper')
              .html(
                '<div class="errors text-center" style="width: 100%;">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (typeof window.google !== 'undefined') {
        google.maps.event.clearListeners(this.map, 'resize');
      }
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  if (!Shopify.designMode) return;

  theme.$currentMapContainer.addClass('page-width map-section--load-error');
  theme.$currentMapContainer.find('.map-section__content-wrapper').remove();
  theme.$currentMapContainer
    .find('.map-section__wrapper')
    .html(
      '<div class="errors text-center" style="width: 100%;">' +
        theme.strings.authError +
        '</div>'
    );
}

theme.stickyHeader = (function() {
  var selectors = {
    searchCartWrapper: '#SiteNavSearchCart',
    stickyNavSearchCart: '#StickyNavSearchCart',
    stickyNavWrapper: '#StickNavWrapper',
    stickyBar: '#StickyBar'
  };

  var config = {
    lastScroll: 0,
    navClass: 'sticky--active',
    openTransitionClass: 'sticky--open',
    closeTransitionClass: 'sticky--close'
  };

  var cache = {};

  function cacheSelectors() {
    cache = {
      $window: $(window),
      $siteNavSearchCart: $(selectors.searchCartWrapper),
      $stickyBar: $(selectors.stickyBar)
    };
  }

  function init() {
    cacheSelectors();
    config.isActive = false;

    // Clone search/cart icons into fixed nav
    if (cache.$siteNavSearchCart.contents().length) {
      cache.$siteNavSearchCart
        .contents()
        .clone()
        .appendTo($(selectors.stickyNavSearchCart));
    }

    cache.$window.on('scroll.stickynav', $.throttle(15, stickyHeaderOnScroll));
  }

  function stickyHeaderOnScroll() {
    var scroll = cache.$window.scrollTop();
    var $el = $(selectors.stickyNavWrapper);
    var threshold = $el.offset().top + $el.height() + 10; // default for scrolling down

    // Check if scrolling up
    if (scroll < config.lastScroll) {
      threshold = $el.offset().top;
    }

    if (scroll > threshold) {
      stickNav();
    } else {
      unstickNav();
    }

    config.lastScroll = scroll;
  }

  function stickNav() {
    if (config.isActive) {
      return;
    }

    config.isActive = true;

    cache.$stickyBar.addClass(config.navClass);

    // Add open transition class after element is set to fixed
    // so CSS animation is applied correctly
    setTimeout(function() {
      cache.$stickyBar.addClass(config.openTransitionClass);
    }, 0);
  }

  function unstickNav() {
    if (!config.isActive) {
      return;
    }

    cache.$stickyBar
      .removeClass(config.openTransitionClass)
      .removeClass(config.navClass);

    config.isActive = false;
  }

  function unload() {
    $(window).off('.stickynav');
  }

  return {
    init: init,
    unload: unload
  };
})();

theme.headerNav = (function() {
  var selectors = {
    stickyNavWrapper: '#StickNavWrapper',
    stickyNav: '#StickyNav'
  };

  function init() {
    sizeNav();
    initMegaNavs();
    $(window).on('resize.headernav', $.debounce(250, sizeNav));
    // Re-measure after web fonts/images load, in case the nav wraps to a second row
    $(window).on('load.headernav', sizeNav);
  }

  // Desktop nav no longer collapses into #SiteNavCompressed when items overflow.
  // Below the small breakpoint the nav is hidden by `small--hide` and the
  // mobile drawer (#mm-drawer, custom.js) takes over.
  function sizeNav() {
    // Set height on nav-bar wrapper so when fixed, doesn't break layout
    $(selectors.stickyNavWrapper).height($(selectors.stickyNav).height());
  }

  function initMegaNavs() {
    new window.Meganav({
      $meganavs: $('.site-nav__dropdown'),
      $meganavToggle: $('.site-nav__link-toggle'),
      preventDuplicates: true,
      closeOnPageClick: true,
      closeThirdLevelOnBlur: true
    });

    new window.Meganav({
      $meganavs: $('.meganav--index'),
      $meganavToggle: $('.index__meganav-toggle')
    });

    new window.Meganav({
      $meganavs: $('.meganav--drawer'),
      $meganavToggle: $('.drawer__meganav-toggle')
    });
  }

  function unload() {
    $(window).off('.headernav');
  }

  return {
    init: init,
    unload: unload
  };
})();


/*================ TEMPLATES ================*/
theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    // check if reset password form was successfully submited
    if (!$('.reset-password-success').length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
theme.HeaderSection = (function() {
  function Header() {
    theme.stickyHeader.init();
    theme.headerNav.init();
    theme.Notify = new window.Notify();
    theme.NavDrawer = new window.Drawers('NavDrawer', 'left');
    drawerSearch();
  }

  function drawerSearch() {
    var $drawerSearch = $('.drawer__search-input');
    var $drawerSearchSubmit = $('.drawer__search-submit');

    $drawerSearchSubmit.on('click', function(evt) {
      if ($drawerSearch.val().length !== 0) {
        return;
      }

      evt.preventDefault();
      $drawerSearch.focus();
    });
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.stickyHeader.unload();
      theme.headerNav.unload();
    }
  });

  return Header;
})();


theme.Filters = (function() {
  var selectors = {
    filterSelection: '#SortTags',
    sortSelection: '#SortBy'
  };

  function Filters() {
    this.$filterSelect = $(selectors.filterSelection);
    this.$sortSelect = $(selectors.sortSelection);

    this.default = this._getDefaultSortValue();
    this.$sortSelect.val(this.default);

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _getDefaultSortValue: function() {
      return Shopify.queryParams.sort_by
        ? Shopify.queryParams.sort_by
        : this.$sortSelect.data('default-sort');
    },

    _onFilterChange: function() {
      delete Shopify.queryParams.page;
      if ($.isEmptyObject(Shopify.queryParams)) {
        location.href = this.$filterSelect.val();
      } else {
        location.href =
          this.$filterSelect.val() + '?' + $.param(Shopify.queryParams);
      }
    },

    _onSortChange: function() {
      Shopify.queryParams.sort_by = this.$sortSelect.val();
      location.search = $.param(Shopify.queryParams);
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

theme.Product = (function() {
  var defaults = {
    smallBreakpoint: 750, // copied from variables.scss
    productThumbIndex: 0,
    productThumbMax: 0,
    ajaxCart: false,
    stockSetting: false
  };

  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.selectors = {
      originalSelectorId: '#ProductSelect-' + sectionId,
      modal: 'ProductModal',
      productZoomImage: '#ProductZoomImg',
      addToCart: '#AddToCart-' + sectionId,
      productPrice: '#ProductPrice-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      SKU: '.variant-sku',
      pdpQuantity: '.product-form__item--quantity',
      variantInventory: '.variant-inventory',
      variantOUT: '.variant-out',
      variantBackorder: '.variant-backorder',
      variantInstock: '.variantInstock',
      productImageContainers: '.product__photo-container-' + sectionId,
      productImageWrappers: '.product__photo-wrapper-' + sectionId,
      productThumbContainers: '.product-single__thumbnail-item-' + sectionId,
      productThumbsWrapper: '.product-single__thumbnails-' + sectionId,
      productThumbs: '.product-single__thumbnail-' + sectionId,
      saleTag: '#ProductSaleTag-' + sectionId,
      productStock: '#ProductStock-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      moqBtn: '.minimumOrderQuantity-btn-klaviyo'
    };

    this.settings = $.extend({}, defaults, {
      sectionId: sectionId,
      ajaxCart: $container.data('ajax'),
      stockSetting: $container.data('stock'),
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.product-' + sectionId
    });

    // Stop parsing if we don't have the product json script tag
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      $('#ProductJson-' + sectionId).html()
    );
    this.addVariantInfo();

    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {
      this._stringOverrides();
      this._initVariants();
      this._productZoomImage();
      this._productThumbSwitch();
      this._productThumbnailSlider();
      this._initQtySelector();

      if (this.settings.ajaxCart) {
        theme.AjaxCart = new window.AjaxCart(
          $('#AddToCartForm-' + this.settings.sectionId)
        );
      }
    },

    _stringOverrides: function() {
      window.productStrings = window.productStrings || {};
      $.extend(theme.strings, window.productStrings);
    },

    addVariantInfo: function() {
      if (!this.productSingleObject || !this.settings.stockSetting) {
        return;
      }

      var variantInfo = JSON.parse(
        $('#VariantJson-' + this.settings.sectionId).html()
      );

      for (var i = 0; i < variantInfo.length; i++) {
        $.extend(this.productSingleObject.variants[i], variantInfo[i]);
      }
    },

    _initVariants: function() {
      // var options = {
      //   $container: this.$container,
      //   enableHistoryState: this.settings.enableHistoryState,
      //   product: this.productSingleObject,
      //   singleOptionSelector: this.selectors.singleOptionSelector,
      //   originalSelectorId: this.selectors.originalSelectorId
      // };

      // eslint-disable-next-line no-new
      //this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCartBtn.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
    },

    _updateStock: function(variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock);

      // If we don't track variant inventory, hide stock
      if (!variant || !variant.inventory_management) {
        $stock.addClass('hide');
        return;
      }

      if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0) {
        $stock
          .html(
            theme.strings.stockAvailable.replace(
              '1',
              variant.inventory_quantity
            )
          )
          .removeClass('hide');
        return;
      }

      if (variant.inventory_quantity <= 0 && variant.incoming) {
        $stock
          .html(
            theme.strings.willNotShipUntil.replace(
              '[date]',
              variant.next_incoming_date
            )
          )
          .removeClass('hide');
        return;
      }

      // If there's more than 10 available, hide stock
      $stock.addClass('hide');
    },

    _updateIncomingInfo: function(variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock);

      if (variant.incoming) {
        $stock
          .html(
            theme.strings.willBeInStockAfter.replace(
              '[date]',
              variant.next_incoming_date
            )
          )
          .removeClass('hide');
        return;
      }

      // If there is no stock incoming, hide stock
      $stock.addClass('hide');
    },

    _updateAddToCartBtn: function(evt) {
      var variant = evt.variant;

      var cache = {
        $addToCart: $(this.selectors.addToCart),
        $addToCartText: $(this.selectors.addToCartText),
        $pdpQuantity: $(this.selectors.pdpQuantity),
        $pdpMoqBtn: $(this.selectors.moqBtn)
      };

      if (variant) {
        // Select a valid variant if available
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
         // $('.product-form__item--quantity').removeClass('hide');
         // cache.$addToCart.removeClass('btn--sold-out').prop('disabled', false);
          //cache.$addToCartText.html(theme.strings.addToCart).removeClass('klaviyo-bis-trigger').addClass('cart__active');
          $(this.selectors.shopifyPaymentButton, this.$container).show();
          //cache.$pdpQuantity.removeClass('hide');
          cache.$pdpMoqBtn.removeClass('backorder-soldout');
          
          // Show how many items are left, if below 10
          this._updateStock(variant);
        } else {
          // Variant is sold out, disable the submit button
          //$('.product-form__item--quantity').addClass('hide');
          //cache.$addToCart.prop('disabled', false).addClass('btn--sold-out');
          //cache.$addToCartText.html(theme.strings.soldOut);
          //cache.$addToCartText.html('ON BACKORDER! Notify Me When Available').addClass('klaviyo-bis-trigger').removeClass('cart__active');
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
          //cache.$pdpQuantity.addClass('hide');
          cache.$pdpMoqBtn.addClass('backorder-soldout');
          // Update when stock will be available
          this._updateIncomingInfo(variant);
        }
      } else {
        cache.$addToCart.prop('disabled', true).removeClass('btn--sold-out');
        cache.$addToCartText.html(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
        cache.$pdpMoqBtn.removeClass('backorder-soldout');
        // Hide stock display
        this._updateStock();
      }
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrice).html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );

        // Update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice)
            .html(
              theme.Currency.formatMoney(
                variant.compare_at_price,
                theme.moneyFormat
              )
            )
            .removeClass('hide');
          $(this.selectors.saleTag).removeClass('hide');
        } else {
          $(this.selectors.comparePrice).addClass('hide');
          $(this.selectors.saleTag).addClass('hide');
        }
      } else {
        $(this.selectors.comparePrice).addClass('hide');
      }
    },
    _updateSKU: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.SKU).html(variant.sku);

           // if (inv_qty[variant.id]) {
             // $(this.selectors.variantInventory).html('<span class="Inst-title">In Stock </span>' + inv_qty[ variant.id ]);
             // $(this.selectors.variantOUT).css('display', 'none').css('height', '0');
              //$(this.selectors.variantInventory).css('display', 'inline-block').css('height', 'auto');
              //$(this.selectors.variantInstock).css('display', 'inline-block').css('height', 'auto'); 
           // }
           // else{
            //  $(this.selectors.variantOUT).html('SOLD OUT');
            //  $(this.selectors.variantOUT).css('display', 'inline-block');
             // $(this.selectors.variantInventory).css('display', 'none').css('height', '0');
             // $(this.selectors.variantInstock).css('display', 'none').css('height', '0'); 
            //}
      
      }
     
     
    },
    

    _updateImages: function(evt) {
      var variant = evt.variant;

      if (variant && variant.featured_image) {
        var imageId = variant.featured_image.id;
        this.switchProductImage(imageId);
        this.setActiveThumbnail(imageId);
      }
    },

    switchProductImage: function(imageId) {
      var $imageToShow = $(
        this.selectors.productImageContainers +
          "[data-image-id='" +
          imageId +
          "']",
        this.$container
      );
      var $imagesToHide = $(
        this.selectors.productImageContainers +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );
      $imagesToHide.addClass('hide');
      $imageToShow.removeClass('hide');
    },

    setActiveThumbnail: function(imageId) {
      var $thumbnailToShow = $(
        this.selectors.productThumbContainers +
          "[data-image-id='" +
          imageId +
          "']",
        this.$container
      );
      var $thumbnailsToHide = $(
        this.selectors.productThumbContainers +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );
      $thumbnailsToHide.removeClass('is-active');
      $thumbnailToShow.addClass('is-active');

      var $thumbnails = $(this.selectors.productThumbsWrapper, this.$container);

      // If there is a slick carousel, get the slide index, and position it into view with animation.
      if ($thumbnails.hasClass('slick-initialized')) {
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var currentActiveSlideIndex = $thumbnails.slick('slickCurrentSlide');
        var newActiveSlideIndex = parseInt(
          $thumbnailToShow.attr('data-slick-index')
        );
        if (currentActiveSlideIndex !== newActiveSlideIndex) {
          $thumbnails.slick('slickGoTo', newActiveSlideIndex, false);
        }
      }
    },

    // _productZoomImage: function() {
    //   // The zoom image is only used on the product template, so return early
    //   // even if a featured product section is present.
    //   if (
    //     !$('.product-single ' + this.selectors.productImageContainers).length
    //   ) {
    //     return;
    //   }

    //   var self = this;

    //   $(this.selectors.productImageWrappers).on(
    //     'click' + this.settings.namespace,
    //     function(evt) {
    //       evt.preventDefault();
    //       // Empty src before loadig new image to avoid awkward image swap
    //       $(self.selectors.productZoomImage)
    //         .attr('src', '')
    //         .attr('src', $(this).attr('href'));
    //     }
    //   );

    //   this.ProductModal = new window.Modals(
    //     this.selectors.modal,
    //     'product-modal'
    //   );

    //   // Close modal if clicked, but not if the image is clicked
    //   this.ProductModal.$modal.on('click' + this.settings.namespace, function(
    //     evt
    //   ) {
    //     if (evt.target.nodeName !== 'IMG') {
    //       self.ProductModal.close();
    //     }
    //   });
    // },
_productZoomImage: function () {
  const $product = $('.product-single');
  if (!$product.length) return;

  const self = this;
  const ns  = (this.settings.namespace || '.theme') + '.zoom';

  // Clean previous bindings within product scope
  $product.off(ns);
  if (self.ProductModal && self.ProductModal.$modal) {
    self.ProductModal.$modal.off(ns);
  }

  // Delegate the click so it survives DOM swaps on variant change
  $product.on('click' + ns, self.selectors.productImageWrappers, function (evt) {
    evt.preventDefault();

    // Ensure modal instance points to the current modal in the DOM.
    // - '#' + id: without it the lookup never matched, so a NEW modal was created on every click.
    // - open: a selector that matches nothing, so Modals doesn't bind its own click handler on the
    //   images. That handler stopped the click before this one ran, so from the second zoom on the
    //   picture was never swapped and the previous image showed. This delegated handler opens it.
    const modalSel = self.selectors.modal;
    if (!self.ProductModal || !document.querySelector('#' + modalSel)) {
      self.ProductModal = new window.Modals(modalSel, 'product-modal', {
        open: '.js-pdp-zoom-no-direct-open',
        focusOnOpen: '#ProductModal .modal__close' // keyboard focus lands on ×
      });
    }

    // Rebind modal close (idempotent)
    self.ProductModal.$modal.off('click' + ns).on('click' + ns, function (e) {
      if (e.target.nodeName !== 'IMG') self.ProductModal.close();
    });

    // Swap the zoom image src. The box takes the clicked image's shape first (--zoom-ar), so it
    // opens at its final size instead of a thin line that grows when the picture arrives.
    var $zoomImg = $(self.selectors.productZoomImage);
    var $thumb = $(this).find('img').first();
    var w = parseFloat($thumb.attr('width'));
    var h = parseFloat($thumb.attr('height'));
    var modalEl = document.getElementById('ProductModal');
    if (modalEl && w > 0 && h > 0) modalEl.style.setProperty('--zoom-ar', String(w / h)); // jQuery 2 can't set CSS variables
    // nothing inside the box shows until the large picture has arrived (just the dimmed page)
    if (modalEl) modalEl.classList.add('is-loading');
    var zoomEl = $zoomImg.get(0);
    var done = function() { if (modalEl) modalEl.classList.remove('is-loading'); };
    if (zoomEl) { zoomEl.onload = done; zoomEl.onerror = done; }
    $zoomImg
      .attr('src', '')
      .attr('src', $(this).attr('href'));
    if (zoomEl && zoomEl.complete && zoomEl.naturalWidth) done(); // already in the browser cache

    // Open with this click as the source, so closing returns focus to the image that was clicked
    if (typeof self.ProductModal.open === 'function') self.ProductModal.open(evt);
  });
},

    _productThumbSwitch: function() {
      if (!$(this.selectors.productThumbs).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbs).on(
        'click' + this.settings.namespace,
        function(evt) {
          evt.preventDefault();
          var imageId = $(this)
            .parent()
            .data('image-id');
          self.setActiveThumbnail(imageId);
          self.switchProductImage(imageId);
        }
      );
    },

    /*
      Thumbnail slider
     */
    _productThumbnailSlider: function() {
      var $productThumbsWrapper = $(this.selectors.productThumbsWrapper);
      var $productThumbs = $(this.selectors.productThumbs);
      if (!$productThumbs.length) {
        return;
      }

      if ($productThumbs.length > 2) {
        $productThumbsWrapper.on(
          'init' + this.settings.namespace,
          this._productSwipeInit.bind(this)
        );

        var nextArrow;
        var prevArrow;
        var sliderArrows = window.sliderArrows || false;

        // sliderArrows is an object defined in product.liquid to set custom
        // SVG arrow icons.
        if (sliderArrows) {
          nextArrow =
            '<button type="button" class="slick-next"><span class="medium-up--hide">' +
            sliderArrows.right +
            '</span><span class="small--hide">' +
            sliderArrows.down +
            '</span></button>';
          prevArrow =
            '<button type="button" class="slick-prev"><span class="medium-up--hide">' +
            sliderArrows.left +
            '</span><span class="small--hide">' +
            sliderArrows.up +
            '</span></button>';
        }

        $productThumbsWrapper.slick({
          accessibility: false,
          arrows: true,
          dots: false,
          infinite: false,
          autoplay: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          vertical: true,
          verticalSwiping: true,
          nextArrow: nextArrow,
          prevArrow: prevArrow,
          responsive: [
            {
              breakpoint: this.settings.smallBreakpoint,
              settings: {
                vertical: false,
                verticalSwiping: false
              }
            }
          ]
        });

        // Show highlighted thumbnail by repositioning slider
        $productThumbsWrapper.slick(
          'slickGoTo',
          $productThumbsWrapper.find('.is-active').attr('data-slick-index'),
          true
        );
      }
    },

    _productSwipeInit: function(evt, obj) {
      // Slider is initialized. Setup custom swipe events
      this.settings.productThumbIndex = obj.currentSlide;
      this.settings.productThumbMax = obj.slideCount - 1; // we need the 0-based index

      var self = this;

      $(this.selectors.productImageWrappers).on(
        'swipeleft swiperight',
        function(event) {
          if (event.type === 'swipeleft') {
            self._goToNextThumbnail();
          }

          if (event.type === 'swiperight') {
            self._goToPrevThumbnail();
          }

          // Trigger click on newly requested thumbnail
          $(
            '.product-single__thumbnail-item[data-slick-index="' +
              self.settings.productThumbIndex +
              '"]'
          )
            .find('.product-single__thumbnail')
            .trigger('click');
        }
      );
    },

    _goToNextThumbnail: function() {
      this.settings.productThumbIndex++;

      if (this.settings.productThumbIndex > this.settings.productThumbMax) {
        this.settings.productThumbIndex = 0;
      }

      $(this.selectors.productThumbsWrapper).slick(
        'slickGoTo',
        this.settings.productThumbIndex,
        true
      );
    },

    _goToPrevThumbnail: function() {
      this.settings.productThumbIndex--;

      if (this.settings.productThumbIndex < 0) {
        this.settings.productThumbIndex = this.settings.productThumbMax;
      }

      $(this.selectors.productThumbsWrapper).slick(
        'slickGoTo',
        this.settings.productThumbIndex,
        true
      );
    },

    _initQtySelector: function() {
      this.$container.find('.product-form__quantity').each(function(i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    onUnload: function() {
      $(this.selectors.productImageWrappers).off(this.settings.namespace);
      $(this.selectors.productThumbs).off(this.settings.namespace);
      $(this.selectors.productThumbs).slick('unslick');
      if (this.ProductModal) {
        this.ProductModal.$modal.off(this.settings.namespace);
      }
    }
  });

  return Product;
})();

theme.Slideshow = (function() {
  function Slideshow() {
    this.slideshow = new theme.Hero();
  }

  Slideshow.prototype = _.assignIn({}, Slideshow.prototype, {
    onUnload: function() {
      this.slideshow.destroy();
    },

    onSelect: function() {
      this.slideshow.pause();
    },

    onDeselect: function() {
      this.slideshow.play();
    },

    onBlockSelect: function(evt) {
      var $slide = $(
        '.hero__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      this.slideshow.pause();
      this.slideshow.goToSlide(slideIndex);
    },

    onBlockDeselect: function() {
      this.slideshow.play();
    }
  });

  return Slideshow;
})();

theme.Cart = (function() {
  var selectors = {
    cartNote: '#CartSpecialInstructions',
    cartQtyInput: '.cart__quantity',
    cartNoCookiesClass: 'cart--no-cookies'
  };

  function Cart(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    theme.cartObject = JSON.parse($('#CartJson-' + sectionId).html());

    this.init($container);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    init: function($container) {
      this._initQtySelector();
      this._initCartNote();

      if (!this._cookiesEnabled()) {
        $container.addClass(selectors.cartNoCookiesClass);
      }
    },

    _initQtySelector: function() {
      $(selectors.cartQtyInput).each(function(i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    _initCartNote: function() {
      if (!$(selectors.cartNote).length) {
        return;
      }

      var $el = $(selectors.cartNote);
      var noteText;
      var params;
      var noteOffset = $el[0].offsetHeight - $el[0].clientHeight;

      // Auto grow the cart note if text fills it up
      $el.on('keyup input', function() {
        $(this)
          .css('height', 'auto')
          .css('height', $el[0].scrollHeight + noteOffset);
      });

      // Save the cart note via ajax. A safeguard in case
      // a user decides to leave the page before clicking 'Update Cart'
      $el.on(
        'change',
        $.proxy(function() {
          noteText = $el.val();
          params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + this._attributeToString(noteText),
            dataType: 'json'
          };
          $.ajax(params);
        }, this)
      );
    },

    _attributeToString: function(attr) {
      if (typeof attr !== 'string') {
        attr = String(attr);
        if (attr === 'undefined') {
          attr = '';
        }
      }
      return $.trim(attr);
    },

    _cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

theme.Quotes = (function() {
  function Quotes(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));

    this.$container.slick({
      accessibility: true,
      arrows: false,
      dots: true,
      draggable: true,
      autoplay: false
    });
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },

    _goToSlide: function(slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function() {
      delete this.$container;
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quote__slide-wrapper--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      this._goToSlide(slideIndex);
    }
  });

  return Quotes;
})();

theme.Video = (function() {
  var promiseYoutubeAPI;
  var promiseVimeoAPI;

  var youtube = {
    promiseAPI: function() {
      if (!promiseYoutubeAPI) {
        var tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        promiseYoutubeAPI = $.Deferred(function(defer) {
          window.onYouTubeIframeAPIReady = defer.resolve;

          setTimeout(function() {
            defer.reject('Request for YouTube API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseYoutubeAPI;
    },
    promisePlayer: function(id, options) {
      return this.promiseAPI().then(function() {
        return $.Deferred(function(defer) {
          if (typeof window.YT === 'undefined') {
            defer.reject(
              "We're sorry, something went wrong. The YouTube API has not loaded correctly."
            );
          }

          /* eslint-disable no-undef */
          var player = new YT.Player(id, options); // global YT variable injected by YouTube API

          player.addEventListener('onReady', function() {
            defer.resolve(player);
          });

          setTimeout(function() {
            defer.reject(
              'Request for YouTube player has timed out after 30 seconds.'
            );
          }, 30000);
        });
      });
    }
  };

  var vimeo = {
    promiseAPI: function() {
      if (!promiseVimeoAPI) {
        promiseVimeoAPI = $.Deferred(function(defer) {
          var tag = document.createElement('script');
          tag.src = 'https://player.vimeo.com/api/player.js';
          tag.onload = tag.onreadystatechange = function() {
            if (!this.readyState || this.readyState === 'complete') {
              defer.resolve();
            }
          };

          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          setTimeout(function() {
            defer.reject('Request for Vimeo API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseVimeoAPI;
    },

    promisePlayer: function(id, options) {
      return this.promiseAPI().then(function() {
        return $.Deferred(function(defer) {
          if (typeof window.Vimeo === 'undefined') {
            defer.reject(
              "We're sorry, something went wrong. The Vimeo API has not loaded correctly."
            );
          }

          var player = new window.Vimeo.Player(id, options);

          setTimeout(function() {
            defer.reject(
              'Request for Vimeo player has timed out after 30 seconds.'
            );
          }, 30000);

          player.ready().then(function() {
            defer.resolve(player);
          });
        });
      });
    }
  };

  var selectors = {
    loadPlayerButton: '.video-section__load-player-button',
    closePlayerButton: '.video-section__player-close',
    playerContainer: '.video-section__player',
    cover: '.video-section__cover',
    errorMessage: '.video-section__error',
    bodyOverlay: '.video-section__body-overlay',
    body: 'body'
  };
  var classes = {
    playerLoading: 'video-section--loading',
    playerLoaded: 'video-section--loaded',
    playerError: 'video-section--error',
    videoPlaying: 'video-playing'
  };

  function Video(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');
    this.namespace = '.' + sectionId;
    this.onLoad();
  }

  Video.prototype = _.assignIn({}, Video.prototype, {
    onLoad: function() {
      this.$container
        .on('click', selectors.loadPlayerButton, this._loadPlayer.bind(this))
        .on('click', selectors.closePlayerButton, this._closePlayer.bind(this))
        .on('click', selectors.bodyOverlay, this._closePlayer.bind(this));
    },

    _loadPlayer: function() {
      var $container = this.$container;
      var $playerContainer = $(selectors.playerContainer, $container);
      var playerType = this.$container.attr('data-video-type');

      var promiseVideoPlayer;

      if (playerType === 'youtube') {
        promiseVideoPlayer = this._loadYoutubePlayer($playerContainer[0]);
      } else if (playerType === 'vimeo') {
        promiseVideoPlayer = this._loadVimeoPlayer($playerContainer[0]);
      }

      return promiseVideoPlayer
        .then(this._onPlayerLoadReady.bind(this))
        .fail(this._onPlayerLoadError.bind(this));
    },

    _loadYoutubePlayer: function(container) {
      return youtube
        .promisePlayer(container, {
          videoId: this.$container.attr('data-video-id'),
          ratio: 16 / 9,
          playerVars: {
            modestbranding: 1,
            autoplay: 1,
            showinfo: 0,
            rel: 0
          }
        })
        .then(
          function(player) {
            this.player = player;
          }.bind(this)
        );
    },

    _loadVimeoPlayer: function(container) {
      return vimeo
        .promisePlayer(container, {
          id: this.$container.attr('data-video-id')
        })
        .then(
          function(player) {
            this.player = player;
            this.player.play();
          }.bind(this)
        );
    },

    _onPlayerLoadReady: function() {
      $(selectors.closePlayerButton, this.$container)
        .show()
        .focus();
      $(selectors.cover, this.$container).addClass(classes.playerLoaded);
      this.$container.addClass(classes.playerLoaded);

      this._setScrollPositionValues();

      $(selectors.body).addClass(classes.videoPlaying);

      $(document).on('keyup' + this.namespace, this._closeOnEscape.bind(this));
      $(window).on(
        'resize' + this.namespace,
        this._setScrollPositionValues.bind(this)
      );
      slate.a11y.trapFocus({
        $container: this.$container,
        namespace: this.namespace
      });
    },

    _onPlayerLoadError: function(err) {
      this.$container.addClass(classes.playerError);
      $(selectors.errorMessage, this.$container).text(err);
    },

    _closeOnEscape: function(evt) {
      if (evt.keyCode !== 27) {
        return;
      }

      this._closePlayer();
      $(selectors.loadPlayerButton, this.$container).focus();
    },

    _onScroll: function() {
      var scrollTop = $(window).scrollTop();

      if (
        scrollTop > this.videoTop + 0.25 * this.videoHeight ||
        scrollTop + this.windowHeight <
          this.videoBottom - 0.25 * this.videoHeight
      ) {
        // Debounce DOM edits to the next frame with requestAnimationFrame
        requestAnimationFrame(this._closePlayer.bind(this));
      }
    },

    _setScrollPositionValues: function() {
      this.videoHeight = this.$container.outerHeight(true);
      this.videoTop = this.$container.offset().top;
      this.videoBottom = this.videoTop + this.videoHeight;
      this.windowHeight = $(window).innerHeight();
    },

    _closePlayer: function() {
      $(selectors.body).removeClass(classes.videoPlaying);
      $(selectors.cover, this.$container).removeClass(classes.playerLoaded);
      this.$container.removeClass(classes.playerLoaded);
      $(selectors.closePlayerButton, this.$container).hide();

      slate.a11y.removeTrapFocus({
        $container: this.$container,
        namespace: this.namespace
      });

      if (typeof this.player.destroy === 'function') {
        this.player.destroy();
      } else if (typeof this.player.unload === 'function') {
        this.player.unload();
      }

      $(document).off(this.namespace);
      $(window).off(this.namespace);
    }
  });

  return Video;
})();

theme.CollectionsList = (function() {
  function CollectionsList(container) {
    var $container = (this.$container = $(container));
    var stretchImage = $container.is('[data-stretch-image]');

    // Early return if 'secondary image layout' is enabled
    if (stretchImage) return;

    var namespace = (this.namespace = '.' + $container.attr('data-section-id'));
    var self = this;

    self._collectionListFix();
    $(window).on(
      'resize' + namespace,
      $.debounce(250, function() {
        self._collectionListFix();
      })
    );
  }

  CollectionsList.prototype = _.assignIn({}, CollectionsList.prototype, {
    onUnload: function() {
      $(window).off(this.namespace);
    },

    _collectionListFix: function() {
      var numberRows = this.$container.find('.grid').data('number-rows');
      var $featureCards = this.$container.find('.featured-card');

      // We can exit if 'Use secondary image layout' is enabled
      if ($featureCards.is('[data-stretch-image]')) return;

      // Go through each of the rows
      for (var i = 0; i < numberRows; i++) {
        var maxWrapperHeight = 0;
        var maxHeaderHeight = 0;
        var $currentRow = $featureCards.filter(
          "[data-row-number='" + (i + 1) + "']"
        );
        var $cardHeaders = $currentRow.find('.featured-card__header');

        // Find the max heights for each row
        $currentRow.each(function() {
          var $cardTitle = $(this).find('.featured-card__title');
          var $cardAction = $(this).find('.featured-card__action');
          var $cardImageWrapper = $(this).find('.featured-card__image-wrapper');
          var headerHeight =
            $cardTitle.outerHeight() + $cardAction.outerHeight() + 65;
          var wrapperHeight = $cardImageWrapper.outerHeight();
          if (headerHeight > maxHeaderHeight) {
            maxHeaderHeight = headerHeight;
          }
          if (wrapperHeight > maxWrapperHeight) {
            maxWrapperHeight = wrapperHeight;
          }
        });

        // Set the heights of the headers and cards for this row with padding
        $cardHeaders.outerHeight(maxHeaderHeight);
        $currentRow.height(maxWrapperHeight + maxHeaderHeight + 40);
      }
    }
  });

  return CollectionsList;
})();


theme.init = function() {
  theme.customerTemplates.init();
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  // Sections
  var sections = new theme.Sections();
  sections.register('header', theme.HeaderSection);
  sections.register('product', theme.Product);
  sections.register('featured-product', theme.Product);
  sections.register('collection-filters', theme.Filters);
  sections.register('map', theme.Maps);
  sections.register('slideshow', theme.Slideshow);
  sections.register('cart', theme.Cart);
  sections.register('quotes', theme.Quotes);
  sections.register('video', theme.Video);
  sections.register('collections-list', theme.CollectionsList);

  // Standalone modules
  $(window).on('load', theme.articleImages);
  theme.passwordModalInit();
};

theme.articleImages = function() {
  var $indentedRteImages = $('.rte--indented-images');
  if (!$indentedRteImages.length) {
    return;
  }

  $indentedRteImages.find('img').each(function(i, el) {
    var $el = $(el);
    var attr = $el.attr('style');

    // Check if undefined or float: none
    if (!attr || attr === 'float: none;') {
      // Add class to parent paragraph tag if image is wider than container
      if ($el.width() >= $indentedRteImages.width()) {
        $el.parent('p').addClass('rte__image-indent');
      }
    }
  });
};

theme.passwordModalInit = function() {
  var $loginModal = $('#LoginModal');
  if (!$loginModal.length) {
    return;
  }

  // Initialize modal
  theme.PasswordModal = new window.Modals('LoginModal', 'login-modal', {
    focusOnOpen: '#Password'
  });

  // Open modal if errors exist
  if ($loginModal.find('.errors').length) {
    theme.PasswordModal.open();
  }
};

$(theme.init);

/* ===== Product gallery: horizontal thumbs + arrows (rebindable) also the copy the active thumb src and past in ID pdp_formImage 2048 ===== */
window.bindProductThumbs = function bindProductThumbs(sectionId) {
  // New gallery (snippets/product-gallery.liquid + assets/pdp-gallery.js): after a colour change,
  // just move it to the new variant's image. The code below only serves the old gallery markup.
  if (window.PdpGallery && document.querySelector('[data-pdp-gallery][data-section-id="' + sectionId + '"]')) {
    window.PdpGallery.sync(sectionId);
    return;
  }

  const root = document.getElementById(`ProductSection-${sectionId}`);
  if (!root) return;

  const mainImg    = root.querySelector(`#MainGalleryImage-${sectionId}`);
  const modalLink  = root.querySelector('.js-modal-open-product-modal');
  const modalImg   = root.querySelector('#ProductZoomImg');
  const thumbsWrap = root.querySelector(`.product-single__thumbnails-${sectionId}`);

  if (!mainImg || !thumbsWrap) return;

  if (thumbsWrap.__pgBound) return;
  thumbsWrap.__pgBound = true;

  const thumbsContainer = thumbsWrap.parentElement;
  const row = document.createElement('div');
  row.className = 'thumb-row';

  const prev = document.createElement('button');
  prev.type = 'button';
  prev.className = 'pg-btn pg-prev';
  prev.innerHTML = window.sliderArrows?.left || '‹';

  const next = document.createElement('button');
  next.type = 'button';
  next.className = 'pg-btn pg-next';
  next.innerHTML = window.sliderArrows?.right || '›';

  thumbsContainer.replaceChild(row, thumbsWrap);
  row.appendChild(prev);
  row.appendChild(thumbsWrap);
  row.appendChild(next);

  const itemSel = `.product-single__thumbnail-item-${sectionId}`;
  const linkSel = 'button.product-thumb';

  function setActive(itemEl) {
    thumbsWrap.querySelectorAll(`${itemSel}.is-active`).forEach(el => {
      el.classList.remove('is-active');
      el.setAttribute('aria-selected', 'false');
    });
    if (itemEl) {
      itemEl.classList.add('is-active');
      itemEl.setAttribute('aria-selected', 'true');
    }
  }

  function updateArrowState() {
    const max = Math.max(0, thumbsWrap.scrollWidth - thumbsWrap.clientWidth);
    const left = Math.round(thumbsWrap.scrollLeft);
    prev.disabled = left <= 0;
    next.disabled = left >= max;
  }

  prev.addEventListener('click', () => {
    const w = thumbsWrap.querySelector(itemSel)?.getBoundingClientRect().width || 100;
    thumbsWrap.scrollBy({ left: -(w * 3), behavior: 'smooth' });
    setTimeout(updateArrowState, 200);
  });

  next.addEventListener('click', () => {
    const w = thumbsWrap.querySelector(itemSel)?.getBoundingClientRect().width || 100;
    thumbsWrap.scrollBy({ left: (w * 3), behavior: 'smooth' });
    setTimeout(updateArrowState, 200);
  });

  function updatePopupFromActiveThumb() {
    const active = thumbsWrap.querySelector(`${itemSel}.is-active`);
    if (!active) return;

    const thumbBtn = active.querySelector(linkSel);
    if (!thumbBtn) return;

    const full = thumbBtn.getAttribute('data-full');
    if (!full) return;

    const zoomUrl = full.replace(/600x|700x|800x|900x|1000x/g, '1024x');

    if (modalLink) {
      modalLink.href = zoomUrl;
      modalLink.setAttribute('data-zoom', zoomUrl);
    }

    if (modalImg) {
      // keep the URL ready, don't download it until the zoom opens (_productZoomImage sets src)
      modalImg.setAttribute('data-src', zoomUrl);
      modalImg.setAttribute('data-image-id', active.getAttribute('data-image-id'));
    }
  }

  function swapTo(itemEl) {
    if (!itemEl) return;

    const thumbBtn = itemEl.querySelector(linkSel);
    if (!thumbBtn) return;

    const full = thumbBtn.getAttribute('data-full');
    if (!full) return;

    const imgId = itemEl.getAttribute('data-image-id');

    // srcset must change with src, or the browser keeps showing the previous image
    const srcset = thumbBtn.getAttribute('data-srcset');
    if (srcset) mainImg.setAttribute('srcset', srcset);
    else mainImg.removeAttribute('srcset');
    mainImg.src = full;
    mainImg.setAttribute('data-image-id', imgId);

    setActive(itemEl);
    updatePopupFromActiveThumb();

    thumbsWrap.scrollTo({
      left: itemEl.offsetLeft - 55,
      behavior: 'smooth'
    });

    setTimeout(updateArrowState, 100);
  }

  thumbsWrap.addEventListener('click', e => {
    const trigger = e.target.closest(linkSel);
    if (!trigger) return;

    e.preventDefault();
    const itemEl = trigger.closest(itemSel);
    swapTo(itemEl);
  });

  thumbsWrap.addEventListener('keydown', e => {
    const items = [...thumbsWrap.querySelectorAll(itemSel)];
    if (!items.length) return;

    const current = thumbsWrap.querySelector(`${itemSel}.is-active`) || items[0];
    const idx = items.indexOf(current);
    let nextIdx = idx;

    if (e.key === 'ArrowRight') nextIdx = Math.min(items.length - 1, idx + 1);
    if (e.key === 'ArrowLeft') nextIdx = Math.max(0, idx - 1);
    if (e.key === 'Home') nextIdx = 0;
    if (e.key === 'End') nextIdx = items.length - 1;

    if (idx !== nextIdx) {
      e.preventDefault();
      const target = items[nextIdx];
      swapTo(target);

      const btn = target.querySelector(linkSel);
      if (btn) btn.focus({ preventScroll: true });
    }
  });

  (function syncAfterVariantChange() {
    const mainImgId = mainImg.getAttribute('data-image-id');

    const target =
      thumbsWrap.querySelector(`${itemSel}[data-image-id="${mainImgId}"]`) ||
      thumbsWrap.querySelector(itemSel);

    if (target) {
      setActive(target);

      thumbsWrap.scrollTo({
        left: target.offsetLeft - 55,
        behavior: 'auto'
      });
    }

    updatePopupFromActiveThumb();
    updateArrowState();
  })();
};

(function () {
  function boot() {
    const sec = document.querySelector('[id^="ProductSection-"]');
    if (!sec) return;

    const sectionId = sec.id.replace('ProductSection-', '');
    if (window.bindProductThumbs) window.bindProductThumbs(sectionId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* End of changes by Adam T ; Feb. 15, 2022 */

window.UploadKit = window.UploadKit || {}
window.UploadKit.config = window.UploadKit.config || {}
window.UploadKit.config.useLatestVersion = true